import { render, staticRenderFns } from "./yc-quota-page.vue?vue&type=template&id=1def32bc&scoped=true&"
import script from "./yc-quota-page.vue?vue&type=script&lang=js&"
export * from "./yc-quota-page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1def32bc",
  null
  
)

export default component.exports